import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

interface Comments {
  technical: string;
  technicalAdministration: string;
  operation: string;
}

const renderCommentField = (
  label: string,
  value: string,
  field: keyof Comments,
  isGeneratingPDF: boolean,
  setComments?: React.Dispatch<React.SetStateAction<Comments>>,
  canEdit?: boolean,
) => {
  if (isGeneratingPDF) {
    return (
      <Box key={field}>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {label}
        </Typography>
        <Box
          sx={{
            minHeight: '80px',
            p: 2,
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            backgroundColor: '#fafafa',
            fontSize: '14px',
            lineHeight: 1.6,
          }}
        >
          <div style={{
            whiteSpace: 'pre-line',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}>
            {value || 'Sin comentarios'}
          </div>
        </Box>
      </Box>
    );
  }

  return (
    <TextField
      key={field}
      label={label}
      multiline
      rows={3}
      value={value}
      onChange={(e) => setComments?.((prev) => ({
        ...prev,
        [field]: e.target.value,
      }))}
      variant="outlined"
      size="small"
      disabled={!canEdit}
    />
  );
};

export default renderCommentField;
